function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import IntlMessage from '../commons/Intl';
import { Action, Label, SessionConfirm } from "../commons/IntlMessages";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // 確認ダイアログモーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 会議削除確認
   */

  Mode[Mode["SessionDeleteConfirm"] = 1] = "SessionDeleteConfirm";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Modal: null
    };
    return _this;
  }
  /**
   * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
   */


  _createClass(MainComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var modal = $('#SessionConfirmDialogModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      });
      var list = document.querySelectorAll(".modal-backdrop");

      for (var i = 0; i < list.length; i++) {
        if (!list[i].classList.contains("nested")) {
          list[i].classList.add("nested");
        }
      } // ポップアップが完全に非表示になった時のイベント。


      modal.on("hidden.bs.modal", function (e) {
        var list = document.querySelectorAll(".modal-backdrop");

        for (var i = 0; i < list.length; i++) {
          if (list[i].classList.contains("nested")) {
            list[i].classList.remove("nested");
          }
        }

        _this2.props.onHidden();
      });
    }
    /**
     * 「はい」ボタン押下時の処理を行います。
     */

  }, {
    key: "onYes",
    value: function onYes() {
      var _this3 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onYes(function () {
        if (_this3.state.Modal == null) {
          throw Error();
        }

        _this3.state.Modal.modal('hide');
      });
    }
    /**
     * 「いいえ」ボタン押下時の処理を行います。
     */

  }, {
    key: "onNo",
    value: function onNo() {
      var _this4 = this;

      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onNo(function () {
        if (_this4.state.Modal == null) {
          throw Error();
        }

        _this4.state.Modal.modal('hide');
      });
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var message = "";

      if (this.props.mode == Mode.SessionDeleteConfirm) {
        message = intl.format(SessionConfirm.SessionDeleteConfirmMessage);
        message = message.replace(/{type}/g, intl.format(Label.Sequence));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionConfirmDialogModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "40",
        height: "42",
        src: "/assets/img/information_icon_side.svg"
      }), this.props.mode == Mode.SessionDeleteConfirm && /*#__PURE__*/React.createElement("h3", null, intl.format(SessionConfirm.SessionDeleteConfirmTitle))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), this.props.mode == Mode.SessionDeleteConfirm && [/*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-8 mx-auto"
      }, message.split('\\n').map(function (str, index) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: index
        }, str, /*#__PURE__*/React.createElement("br", null));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onYes.bind(this),
        className: "btn btn-primary",
        tabIndex: -1
      }, intl.format(Action.Yes)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.onNo.bind(this),
        className: "btn btn-default",
        tabIndex: -1
      }, intl.format(Action.No)))])));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };